import { z } from 'zod';

/** Una scheda (tab) aperta nel browser di una scheda di Regia. */
export interface BrowserTab {
  id: string;
  title: string;
  url: string;
  active: boolean;
}

/** Stato del browser dedicato a una scheda. */
export interface BrowserState {
  running: boolean;
  /** Vista da telefono (stretta) invece che da computer. */
  mobile: boolean;
  url: string;
  title: string;
  tabs: BrowserTab[];
  /** Cresce a ogni cambiamento: si passa a /frame per aspettare il successivo. */
  version: number;
  /** Ultima immagine dello schermo (JPEG in base64) e misure della pagina che mostra. */
  frame: { data: string; width: number; height: number } | null;
  /** Quando l'agente ha usato il browser l'ultima volta. */
  agentAt: string | null;
}

export const browserInputSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('click'), x: z.number().min(0).max(1), y: z.number().min(0).max(1) }),
  z.object({
    type: z.literal('scroll'),
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    dx: z.number().min(-5000).max(5000),
    dy: z.number().min(-5000).max(5000),
  }),
  z.object({ type: z.literal('text'), text: z.string().min(1).max(5000) }),
  z.object({
    type: z.literal('key'),
    key: z.string().min(1).max(20),
    ctrl: z.boolean().optional(),
    shift: z.boolean().optional(),
    alt: z.boolean().optional(),
  }),
  z.object({ type: z.literal('navigate'), url: z.string().trim().min(1).max(2000) }),
  z.object({ type: z.enum(['back', 'forward', 'reload', 'newTab']) }),
  z.object({ type: z.enum(['tab', 'closeTab']), id: z.string().min(1).max(100) }),
  z.object({ type: z.literal('mobile'), on: z.boolean() }),
]);
export type BrowserInput = z.infer<typeof browserInputSchema>;
